import { useEffect, useState } from 'react';
import useQueryParams from '../utils/hooks/useGetParams';
import {
  IReactivateMembershipContext,
  useReactivateMyMembershipContext,
} from '../utils/ContextProviders/ReactivateContext';

const defaultMessage = 'Only one promo code can be used at a time';

const useCouponSelector = (couponChangeCallback = () => { }) => {
  const { setCouponsApplied: setCouponAppliedContext } =
    useReactivateMyMembershipContext();
  const search = useQueryParams();
  const [couponCode, setCouponCode] = useState('');
  const [couponsApplied, setCouponApplied] = useState([]);
  const [couponError, setCouponError] = useState({
    message: '',
  });
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    const initialCouponCode = search?.coupon_code;
    if (initialCouponCode) {
      setCouponCode(initialCouponCode);
    }
  }, [search])

  const handleApplyCoupon = (code, currentDiscount) => {
    const codeLowerCase = code.toLowerCase();
    const couponCode = [{ message: `Promo code ${codeLowerCase} applied!`, type: 'coupon_code', code: codeLowerCase }]
    // This set the coupon code on variation A
    setCouponAppliedContext(couponCode)
    // This set the coupon code on variation control
    setCouponApplied(couponCode);
    const formattedCode = Number(currentDiscount);
    if (currentDiscount) {
      setDiscount(formattedCode);
    }
    couponChangeCallback(codeLowerCase);
  };

  useEffect(() => {
    if (couponError?.message) {
      if (couponError?.message !== defaultMessage) {
        setCouponApplied([]);
        setCouponAppliedContext([]);
        setDiscount(0);
      }
    }
  }, [couponError?.message])

  const handleRemoveCoupon = () => {
    setCouponAppliedContext([]);
    setCouponApplied([]);
    setCouponError({});
    setDiscount(0);
    couponChangeCallback('');
    setCouponCode('');
  };

  return {
    handleApplyCoupon,
    handleRemoveCoupon,
    setCouponError,
    couponsApplied,
    couponError,
    discount,
    couponCode,
  };
};

export default useCouponSelector;
